import React from "react";
import { Icon } from "library";

import * as styles from "./RaceWeather.module.scss";

type RaceWeatherProps = {
  weather: string;
  trackCondition?: string;
  surface?: string;
  trackRating?: string;
};

const humanReadableSurfaceMap: Record<string, string> = {
  T: "Turf",
  S: "Sand",
  AW: "Syn",
  D: "Dirt",
};

const getIconByWeather = (weather: string) => {
  if (["fine", "clear"].some((match) => weather.includes(match))) {
    return "weatherFine";
  }

  if (weather.includes("heavy")) return "weatherHeavy";

  if (["rain", "showers", "shwry"].some((match) => weather.includes(match))) {
    return "weatherShowers";
  }

  if (
    ["clouds", "cloudy", "overcast", "ocast"].some((match) =>
      weather.includes(match),
    )
  ) {
    return "weatherOvercast";
  }

  return null;
};

const RaceWeather = ({
  weather,
  trackCondition,
  surface,
  trackRating,
}: RaceWeatherProps) => {
  const icon = weather ? getIconByWeather(weather.toLowerCase()) : null;
  const humanSurface = surface ? humanReadableSurfaceMap[surface] : null;

  return (
    <div className={styles.container}>
      {icon ? <Icon type={icon} svg /> : weather}
      {trackCondition &&
      trackCondition !== "N/A" &&
      trackCondition !== "unknown" ? (
        <div className={styles.trackCondition}>
          {surface !== "T" ? humanSurface : trackCondition}
          {trackRating ? ` ${trackRating}` : null}
        </div>
      ) : null}
    </div>
  );
};

export { RaceWeather };
